// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CiCircleTwoToneSvg from "@fishx/icons-svg/es/asn/CiCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var CiCircleTwoTone = function CiCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CiCircleTwoToneSvg
  }));
};

CiCircleTwoTone.displayName = 'CiCircleTwoTone';
export default React.forwardRef(CiCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CiCircleTwoTone.js
// module id = 2209
// module chunks = 0